(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_layouts/card-puff-video/assets/javascripts/render-component.js') >= 0) return;  svs.modules.push('/components/banner_layouts/card-puff-video/assets/javascripts/render-component.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const isServer = typeof exports === 'object';

async function renderComponent(model, widgetInfo, position, req, res) {
  var _res$locals, _svs$core, _model$contentType;
  let hbsCompiled;
  let format;
  let isAdmin;
  let solidTangoVideoComponent;
  let youTubeVideoComponent;
  const trinidad = isServer && require('@svenskaspelab/trinidad-core').core;
  const features = isServer ? (res === null || res === void 0 || (_res$locals = res.locals) === null || _res$locals === void 0 ? void 0 : _res$locals.features) || [] : ((_svs$core = svs.core) === null || _svs$core === void 0 || (_svs$core = _svs$core.data) === null || _svs$core === void 0 ? void 0 : _svs$core.features) || [];
  if (isServer) {
    const hbs = global.internalInstances.get('hbs');
    hbsCompiled = hbs.cache['components-banner_layouts-card_puff_video-card_puff_video'];
    format = trinidad.components.require('utils', 'format').api;
    isAdmin = req.userSession.hasRole(req.userSession.roles.INTERNAL);
    solidTangoVideoComponent = trinidad.components.require('components', 'video-player');
    youTubeVideoComponent = trinidad.components.require('components', 'youtube-video');
  } else {
    hbsCompiled = svs.banner_layouts.card_puff_video.templates.card_puff_video;
    format = svs.utils.format;
    isAdmin = svs.core.userSession.hasRole(svs.core.userSession.roles.INTERNAL);
    solidTangoVideoComponent = svs.components.video_player.contentLoader;
    youTubeVideoComponent = svs.components.youtube_video.utils;
  }
  const bannerHelpers = isServer ? trinidad.components.require('banner_common', 'banner-helpers') : svs.banner_common.banner_helpers;
  const {
    getCallToAction,
    groupNumbers
  } = bannerHelpers;
  const getVideoModel = video => {
    if (video === undefined) {
      return '';
    }
    let model;
    if (video.type === 'youtube') {
      youTubeVideoComponent.loadVideo({
        api: false,
        type: video.type,
        videoId: video.id || video.videoId,
        title: video.title ? video.title : "video-".concat(video.id || video.videoId),
        duration: video === null || video === void 0 ? void 0 : video.duration,
        thumbnail: video === null || video === void 0 ? void 0 : video.thumbnail,
        publishedAt: video === null || video === void 0 ? void 0 : video.publishedAt
      }, (err, videoModel) => {
        if (err) {
          throw new Error(err);
        } else {
          model = videoModel;
        }
      });
      return model;
    }
    solidTangoVideoComponent.loadVideo({
      api: false,
      type: video.type || 'solidtango',
      videoId: video.id || video.videoMediaId,
      title: video.title ? video.title : 'video',
      duration: video === null || video === void 0 ? void 0 : video.duration,
      thumbnail: video === null || video === void 0 ? void 0 : video.thumbnail,
      publishedAt: video === null || video === void 0 ? void 0 : video.publishedAt,
      width: '613',
      height: '246.73'
    }, (err, videoModel) => {
      if (err) {
        throw new Error(err);
      } else {
        model = videoModel;
      }
    });
    return model;
  };
  const {
    callToActions: modelCallToActions,
    id: bannerId,
    layoutConfig,
    layoutType,
    targetOffer,
    title,
    videos
  } = model;
  const contentType = (model === null || model === void 0 || (_model$contentType = model.contentType) === null || _model$contentType === void 0 ? void 0 : _model$contentType.split(':').pop()) || 'banner';
  const crm = targetOffer || '';
  const actionViewConfig = {
    block: true,
    inverted: true
  };
  const callToActions = modelCallToActions ? modelCallToActions.map(action => {
    const callToAction = getCallToAction(action, actionViewConfig);
    return callToAction;
  }) : [];
  const trackingStringTitle = format.safeString(title);
  const trackingString = "".concat(widgetInfo.widgetType, "/").concat(widgetInfo.trackingId, "/").concat(position, "/").concat(layoutType, "/").concat(trackingStringTitle);
  const video = videos !== null && videos !== void 0 && videos[0] ? getVideoModel(videos[0]) : getVideoModel(videos);
  const heading = groupNumbers(layoutConfig === null || layoutConfig === void 0 ? void 0 : layoutConfig.header);
  const content = groupNumbers(layoutConfig === null || layoutConfig === void 0 ? void 0 : layoutConfig.content);
  return hbsCompiled(_objectSpread(_objectSpread({}, layoutConfig), {}, {
    features,
    heading,
    content,
    contentType,
    isAdmin,
    crm,
    video,
    callToActions,
    bannerId,
    noLabel: (layoutConfig === null || layoutConfig === void 0 ? void 0 : layoutConfig.product) === 'ingen',
    trackingString
  })) || '';
}
if (isServer) {
  module.exports = {
    renderComponent
  };
} else {
  svs.banner_layouts.card_puff_video.renderComponent = renderComponent;
}

 })(window);